import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from 'vue';

import { ObjectType } from '@/@types/graphql-types';
import { ListMutationTitleDetailParam } from '@/helpers/providers/title-actions-provider';

import { ModalHelper } from '@/helpers/modal-helper';

import BaseModal from '@/components/modals/BaseModal.vue';
import ChipButton from '@/ui-components/ChipButton.vue';

import { faCheckCircle, faTimes, faThumbsUp, faThumbsDown } from '@fortawesome/free-solid-svg-icons';
import { useI18n } from '@/helpers/composables/useI18n';
import { useListActions } from '@/helpers/composables/useListActions';


export default /*#__PURE__*/_defineComponent({
  __name: 'LikeDislikePollModal',
  props: {
    modalTitle: null,
    titleId: null,
    titleDetails: null
  },
  setup(__props: any) {

const props = __props as {
	modalTitle: string;
	titleId: string;
	titleDetails: ListMutationTitleDetailParam;
};



const { t } = useI18n();
const { setInDislikelist, setInLikelist } = useListActions();

const timeoutID = ref<ReturnType<typeof setTimeout> | null>(null);

const questionText = computed(() => {
	const titleType = props.titleDetails.objectType === ObjectType.Movie ? 'WEBAPP_MOVIE' : 'WEBAPP_SHOW';
	return t('WEBAPP_DID_YOU_LIKE_THE', { titleType: t(titleType) });
});

function onLike() {
	setInLikelist(props.titleId, false, false, props.titleDetails, {
		source: 'like_dislike_poll_modal',
	});
	close();
}

function onDislike() {
	setInDislikelist(props.titleId, false, false, props.titleDetails, {
		source: 'like_dislike_poll_modal',
	});
	close();
}

function onMouseOver() {
	if (timeoutID.value) {
		clearTimeout(timeoutID.value);
	}
}

function onMouseLeave() {
	setTimeoutToClose();
}

function close() {
	ModalHelper.close('like_dislike_poll_modal');
}

function setTimeoutToClose() {
	timeoutID.value = setTimeout(() => close(), 4500);
}

onMounted(() => {
	setTimeoutToClose();
});

return { __sfc: true,props, t, setInDislikelist, setInLikelist, timeoutID, questionText, onLike, onDislike, onMouseOver, onMouseLeave, close, setTimeoutToClose, BaseModal, ChipButton, faCheckCircle, faTimes, faThumbsUp, faThumbsDown }
}

})